export interface Parameters {
  [key: string]: string | undefined
}

export const interpolateTerms = (
  text: string | undefined,
  parameters: Parameters
) => {
  if (!text) {
    return ''
  }
  return text.replace(/\{\{([^}]+)\}\}/g, (match, key) => {
    return parameters[key] || match
  })
}
